import { v4 as uuidv4 } from 'uuid';

const projects = [
  {
    id: uuidv4(),
    name: 'Live Streaming Plateform (Best Entertainment)',
    desc: 'An application provide you to host a live video Streaming over a single cloud server in react.js.technologies contain google authentication, RTMP server and nodeedia server.',
    link: 'https://github.com/mustafakaranja/Best-Entertainment-Web-Application-',
    git: 'https://github.com/mustafakaranja/Best-Entertainment-Web-Application-',
  },
  {
    id: uuidv4(),
    name: 'Image Search console in react',
    desc: 'An application is use for image search all over the web',
    link: 'https://pics-henna.vercel.app/',
    git: 'https://github.com/mustafakaranja/Pics_Search',
  },
  {
    id: uuidv4(),
    name: 'Feedback collection applicaiton in react.js (fullstuck application)',
    desc: 'An application help us to take a survey over 1 lakh+ emails, Contain sendgrid intigration, google Oauth intigration, MongoDb intigration',
    link: 'https://aqueous-dusk-90984.herokuapp.com/',
    git: 'https://git.heroku.com/aqueous-dusk-90984.git',
  },
  {
    id: uuidv4(),
    name: 'Video Search in JavaScript',
    desc: 'An application is use for Video search all over the web. just like Youtube',
    link: 'https://videos-search-98e17.web.app/',
    git: 'https://github.com/mustafakaranja/wd-search',
  },
  {
    id: uuidv4(),
    name: 'Season detector in javascript',
    desc: 'This appication is use for detecting you currect weather detection on you live location.',
    link: 'https://github.com/mustafakaranja/Find-the-season-automatically-by-refering-you-current-location',
    git: 'https://github.com/mustafakaranja/Find-the-season-automatically-by-refering-you-current-location',
  },
  {
    id: uuidv4(),
    name: 'Portfolio',
    desc: 'Software engineer portfolio',
    link: 'https://github.com/mustafakaranja/NewPortfolio',
    git: 'https://github.com/mustafakaranja/NewPortfolio',
  },
  {
    id: uuidv4(),
    name: 'tic tak toe game in python',
    desc: 'simple game in python',
    link: 'https://github.com/mustafakaranja/Tic-Tak-Toe-in-python',
    git: 'https://github.com/mustafakaranja/Tic-Tak-Toe-in-python',
  },
  {
    id: uuidv4(),
    name: 'Astroid shoot game in react.js',
    desc: 'Technologies contain , vector.js, canvas.js, math',
    link: 'https://github.com/mustafakaranja/Arteroid-shoot-game',
    git: 'https://github.com/mustafakaranja/Arteroid-shoot-game',
  },
  {
    id: uuidv4(),
    name: 'Snake game in react.js',
    desc: 'Technologies contain , vector.js, canvas.js, math',
    link: 'https://tttgame.vercel.app/Games',
    git: 'https://github.com/mustafakaranja/Snakegame',
  },
  {
    id: uuidv4(),
    name: 'Drowing Pad in react.js',
    desc: 'Technologies contain, canvas.js, math',
    link: 'https://tttgame.vercel.app/',
    git: 'https://vercel.com/mustufakaranja/tttgame/9nyy3PDciGTxZvhAUceDn2FHj9rZ/source',
  },
  {
    id: uuidv4(),
    name: 'Language Translator',
    desc: 'Simple application for translating any language in React.js',
    link: 'https://widgets-zeta-seven.vercel.app/translation',
    git: 'https://github.com/mustafakaranja',
  },
  {
    id: uuidv4(),
    name: 'Accordion function',
    desc: 'Accordion funtion in React.js',
    link: 'https://widgets-zeta-seven.vercel.app/',
    git: 'https://widgets-zeta-seven.vercel.app/',
  },
  {
    id: uuidv4(),
    name: 'Wikipedia Search web Application in React.js',
    desc: 'Search what you want and get ans from Wikipedia',
    link: 'https://widgets-zeta-seven.vercel.app/wiki',
    git: 'https://widgets-zeta-seven.vercel.app/wiki',
  },
  {
    id: uuidv4(),
    name: 'Login Form',
    desc: 'Attractive Login form in React.js',
    link: 'https://github.com/mustafakaranja/Loginform',
    git: 'https://github.com/mustafakaranja/Loginform',
  },
  {
    id: uuidv4(),
    name: 'Wordpress E-commerce site',
    desc: 'Ecommerce live website name Wrapmyphone.in, fully developed and design by me and sold commercially.',
    link: 'http://wrapmyphone.in/',
    git: 'http://wrapmyphone.in/',
  },
  {
    id: uuidv4(),
    name: 'Wordpress E-commerce site',
    desc: 'Ecommerce live website name wrapdecor.in, fully developed and design by me and sold commercially.',
    link: 'https://wrapdecor.in/',
    git: 'https://wrapdecor.in/',
  },
  {
    id: uuidv4(),
    name: 'Wordpress E-commerce site',
    desc: 'Ecommerce live website name creativeKona.com, fully developed and design by me and sold commercially.',
    link: 'https://thecreativekona.com/',
    git: 'https://thecreativekona.com/',
  },
  {
    id: uuidv4(),
    name: 'Business website',
    desc: 'Business live website name Photo-G tech.in, fully developed and design by me and sold commercially.',
    link: 'https://photogtech.in/',
    git: 'https://photogtech.in/',
  },
  {
    id: uuidv4(),
    name: 'Wordpress E-commerce',
    desc: 'E-commerce live website name Artsregal.com, fully developed and design by me and sold commercially.',
    link: 'https://artsregal.com/',
    git: 'https://artsregal.com/',
  },
];

export default projects;
